import { render, staticRenderFns } from "./CadastroTemporario.vue?vue&type=template&id=51f3e8a8&"
import script from "./CadastroTemporario.vue?vue&type=script&lang=js&"
export * from "./CadastroTemporario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports